import React from "react";
import "./Loader.css";

function Loader({ text = "Loading...", variant = "page" }) {
  return (
    <div className={`app-loader app-loader-${variant}`} role="status" aria-live="polite">
      <span className="app-loader-spinner" aria-hidden="true" />
      <span className="app-loader-text">{text}</span>
    </div>
  );
}

export default Loader;
